/* eslint-disable @typescript-eslint/no-explicit-any */
import { Directive, HostListener, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[notchmarkPriceOnly]',
  standalone: true,
})
export class RentalPriceOnlyDirective {
  private readonly ngControl = inject(NgControl);

  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    const inputChar = event.key;
    const currentValue = (event.target as HTMLInputElement).value;

    // allow only digits and one "."
    if (inputChar === '.' && currentValue.includes('.')) {
      event.preventDefault();
      return;
    }
    if (!/[0-9.]/.test(inputChar)) {
      event.preventDefault();
      return;
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const pastedInput: string = event.clipboardData?.getData('text/plain') || '';
    const currentValue = (event.target as HTMLInputElement).value;
    const finalValue = (currentValue + pastedInput).replace(/,/g, '');
    // up to 10 digits before decimal, up to 2 after
    if (!/^\d{0,10}(\.\d{0,2})?$/.test(finalValue)) {
      event.preventDefault();
    }
  }

  @HostListener('input', ['$event'])
  onInput(event: any) {
    let rawValue: string = event.target.value;

    // remove commas & invalid chars
    rawValue = rawValue.replace(/,/g, '').replace(/[^0-9.]/g, '');

    // keep only first decimal
    const parts = rawValue.split('.');
    if (parts.length > 2) {
      rawValue = parts[0] + '.' + parts[1];
    }

    // enforce max digits (10 before, 2 after)
    const match = rawValue.match(/^(\d{0,10})(?:\.(\d{0,2})?)?/);
    if (match) {
      rawValue = match[1] + (match[2] !== undefined ? '.' + match[2] : '');
    }

    // re-split after sanitizing
    const [intPart, decimalPart] = rawValue.split('.');

    // format integer with commas
    let formattedValue = intPart
      ? new Intl.NumberFormat('en-US').format(Number(intPart))
      : '';

    if (rawValue.includes('.')) {
      formattedValue += '.' + (decimalPart ?? '');
    }

    // update UI
    event.target.value = formattedValue;

    // update FormControl
    if (rawValue === '' || rawValue === '.') {
      this.ngControl.control?.setValue(null, { emitEvent: false });
    } else {
      // 👉 keep as string during typing (so "123." or "123.4" are valid)
      this.ngControl.control?.setValue(rawValue, { emitEvent: false });
    }
  }

  @HostListener('blur', ['$event'])
  onBlur(event: any) {
    const inputValue: string = event.target.value.replace(/,/g, '');
    if (inputValue && !isNaN(Number(inputValue))) {
      const numericValue = Number(inputValue);
      // format UI
      event.target.value = new Intl.NumberFormat('en-US').format(numericValue);
      // 👉 convert to number in FormControl for API use
      this.ngControl.control?.setValue(numericValue, { emitEvent: false });
    }
  }
}



